import {FormattedCurrency} from './formatted-currency';
import React, {ReactNode} from 'react';
import {Price} from '../billing/price';
import {Trans} from './trans';
import clsx from 'clsx';

interface FormattedPriceProps {
  price?: Omit<Price, 'id'>;
  variant?: 'slash' | 'separateLine';
  className?: string;
  priceClassName?: string;
  periodClassName?: string;
  // forwarded to FormattedCurrency: whole amounts drop the ".00"
  hideDecimalsWhenWhole?: boolean;
  // opt-in replacement for the default interval word ("day"/"month"),
  // e.g. a clearer adverbial label like "يومياً"
  periodLabel?: ReactNode;
}
export function FormattedPrice({
  price,
  variant = 'slash',
  className,
  priceClassName,
  periodClassName,
  hideDecimalsWhenWhole,
  periodLabel,
}: FormattedPriceProps) {
  if (!price) return null;

  const translatedInterval = periodLabel ?? <Trans message={price.interval} />;

  return (
    <div className={clsx('flex gap-6 items-center', className)}>
      <div className={priceClassName}>
        <FormattedCurrency
          value={price.amount / (price.interval_count ?? 1)}
          currency={price.currency}
          hideDecimalsWhenWhole={hideDecimalsWhenWhole}
        />
      </div>
      {variant === 'slash' ? (
        <div className={periodClassName}> / {translatedInterval}</div>
      ) : (
        <div className={periodClassName}>
          <Trans message="per" /> <br /> {translatedInterval}
        </div>
      )}
    </div>
  );
}
